import React from 'react';

import s from './styles.module.css';

type Props = {
  children?: React.ReactNode;
};

const Section = ({ children }: Props) => <section className={s.content}>{children}</section>;

export { Section };
